import { defineFetch } from 'resift';

const makeDeleteWidget = defineFetch({
  displayName: 'Delete Widget',
  share: {
    namespace: 'widgets',
  },
  make: () => ({
    request: (widgetId: string) => ({ http }) =>
      http({
        method: 'DELETE',
        route: `/widgets/${widgetId}`,
      }),
  }),
});

const deleteWidget = makeDeleteWidget();

export default deleteWidget;
